export var ErrorVerbiage = {
    Retriable: 'Payment could not be processed. Please review your card information and try again.',
    NonRetriable: 'Payment could not be processed. Please enter a different payment method and try again.',
    SystemError: 'Payment could not be processed. Please try again.'
};
